import { Typography } from '@mui/material';
import { useWagmiAuth } from 'app/providers';

import { GENESIS_PRIVILEGES_LINK } from './constants';
import { SaleForm } from './form';
import { BackgroundCard } from './styled';

export const CitCrowdsaleWidget = () => {
  const { state: authState } = useWagmiAuth();
  return (
    <BackgroundCard>
      <Typography textAlign="center" variant="h5" letterSpacing="0.5%" className="primary regular" mb={1.5}>
        Unlock Exclusive Access to $CIT Token Genesis Mint <br />
        <Typography variant="inherit" component="span" className="secondary regular">
          Only 0.1% of the Total Supply Is Mintable
        </Typography>
      </Typography>
      <Typography
        component="a"
        href={GENESIS_PRIVILEGES_LINK}
        referrerPolicy="no-referrer"
        rel="noreferrer"
        target="_blank"
        className="secondary regular"
        sx={{
          textDecoration: 'underline',
          mb: 1.5,
        }}
      >
        Genesis Holder Privileges
      </Typography>
      <SaleForm key={authState.address} />
    </BackgroundCard>
  );
};
